import { render, staticRenderFns } from "./avatar-uploader.vue?vue&type=template&id=40790344&scoped=true&"
import script from "./avatar-uploader.vue?vue&type=script&lang=ts&"
export * from "./avatar-uploader.vue?vue&type=script&lang=ts&"
import style0 from "./avatar-uploader.vue?vue&type=style&index=0&id=40790344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40790344",
  null
  
)

export default component.exports